import { CardRow } from 'components/CardRow';
import { ICONS } from 'components/Icon';
import { Txt } from 'components/Txt';
import { useSelector } from 'hooks/useSelector';
import { pluralise } from 'lib/pluralise';
import { stringRemoveNewLines } from 'lib/riskbase';
import { theme } from 'lib/theme';
import React from 'react';
import { useDispatch } from 'react-redux';
import { REMOTE_ASESETUP_ANSWERDELETE } from 'store/remote/actions';
import {
  selectAseSetupAnswerHasActions,
  selectAseSetupLibraryAnswer,
} from 'store/remote/selectors';

type Props = {
  id: number;
  onPress: () => void;
};

export const AnswerRow: React.FC<Props> = ({ id, onPress }) => {
  const dispatch = useDispatch();

  const answer = useSelector((state) => selectAseSetupLibraryAnswer(state, id));

  const actions = useSelector((state) =>
    selectAseSetupAnswerHasActions(state, id),
  );

  if (!answer) {
    return null;
  }

  return (
    <CardRow
      onPress={onPress}
      menuOptions={[
        {
          text: 'Open Answer',
          icon: ICONS.CircleInfoLight,
          onPress,
        },
        {
          text: 'Delete Answer',
          icon: ICONS.TrashCanLight,
          destructive: true,
          onPress: () =>
            dispatch(
              REMOTE_ASESETUP_ANSWERDELETE({
                id,
              }),
            ),
        },
      ]}
    >
      <Txt size="small" numberOfLines={2}>
        {stringRemoveNewLines(answer.answer)}
        {!!answer.description && (
          <Txt size="small" style={{ color: theme.colors.fieldValueText }}>
            {' '}
            {stringRemoveNewLines(answer.description)}
          </Txt>
        )}
      </Txt>
      {(answer.negative || !!actions.length) && (
        <Txt size="xxxsmall" style={{ color: theme.colors.fieldValueText }}>
          {answer.negative && (
            <Txt
              style={{
                color: theme.colors.red,
              }}
              size="xxxsmall"
            >
              Negative
            </Txt>
          )}
          {answer.negative && !!actions.length && ' • '}
          {!!actions.length && (
            <Txt
              size="xxxsmall"
              style={{
                color: theme.colors.assessmentAction,
                alignSelf: 'center',
              }}
            >
              {pluralise(
                actions.length,
                '1 Action',
                '{x} Actions',
                'No Actions',
              )}
            </Txt>
          )}
        </Txt>
      )}
    </CardRow>
  );
};
